import React, { useEffect } from 'react';

/**
 * AuthCallback - Legacy email verification callback handler
 *
 * This page is kept for backward compatibility with old verification emails
 * that may still have the old /auth/callback redirect URL.
 * It simply redirects to the Verified page.
 */
function AuthCallback() {
    useEffect(() => {
        // Immediately redirect to the Verified page
        // The Verified page will handle clearing the session
        console.log('Legacy auth callback - redirecting to Verified page');
        window.location.href = '/?view=verified';
    }, []);

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#E2DFD2',
            padding: '20px'
        }}>
            <div style={{
                backgroundColor: '#F5F3ED',
                borderRadius: '16px',
                padding: '48px',
                maxWidth: '500px',
                width: '100%',
                textAlign: 'center',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.03)'
            }}>
                <div style={{
                    width: '64px',
                    height: '64px',
                    border: '4px solid #E2DFD2',
                    borderTop: '4px solid #333',
                    borderRadius: '50%',
                    margin: '0 auto 24px',
                    animation: 'spin 1s linear infinite'
                }}></div>
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}
                </style>
                <h2 style={{
                    fontSize: '24px',
                    fontWeight: '600',
                    color: '#333',
                    marginBottom: '12px'
                }}>
                    Redirecting...
                </h2>
                <p style={{
                    fontSize: '16px',
                    color: '#666',
                    marginBottom: '0'
                }}>
                    Please wait...
                </p>
            </div>
        </div>
    );
}

export default AuthCallback;
